// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import LandingPage from './components/LandingPage';
import LoginView from './components/LoginView';
import CrearCredenciales from './components/CrearCredenciales';
import ResetPasswordForm from './components/ResetPasswordForm';
import BookMe from './components/BookMe';
import TermsOfService from './views/Legal/TermsOfService';
import PrivacyPolicy from './views/Legal/PrivacyPolicy';
import EcommerceLanding from './views/Public/EcommerceLanding';
import CheckoutPage from './views/Public/CheckoutPage';

import adminRoutes from './routes/adminRoutes';
import clientRoutes from './routes/clientRoutes';
import sellerRoutes from './routes/sellerRoutes';
import warehouseRoutes from './routes/warehouseRoutes';
import technicianRoutes from './routes/technicianRoutes';
import FloatingCart from './components/FloatingCart';
import { CartProvider } from './context/CartContext';

function App() {
  return (
    <CartProvider>
      <>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginView />} />
          <Route path="/crear-credenciales" element={<CrearCredenciales />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/bookme" element={<BookMe />} />
          <Route path="/ecommerce" element={<EcommerceLanding />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/terminos" element={<TermsOfService />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />

          {/* Rutas cliente */}
          {clientRoutes}

          {/* Rutas admin */}
          {adminRoutes}
          {/* Rutas vendedores */}
          {sellerRoutes}
          {/* Rutas almacén */}
          {warehouseRoutes}
          {/* Rutas técnicos */}
          {technicianRoutes}

          {/* Fallback */}
          <Route path="*" element={<h2>Página no encontrada</h2>} />
        </Routes>
        <FloatingCart />
      </>
    </CartProvider>
  );
}

export default App;
